import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useT } from "../lib/useLanguage";

export default function MatchActionModal({ card, onWriteNow, onSaveLater, onClose }) {
  const t = useT();
  if (!card) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-end justify-center"
        style={{ backgroundColor: "rgba(16,24,40,0.6)" }}
        onClick={onClose}
      >
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", damping: 26, stiffness: 300 }}
          onClick={e => e.stopPropagation()}
          className="w-full max-w-lg rounded-t-3xl p-6"
          style={{ backgroundColor: "#FFF4E8" }}
        >
          {/* Swap match indicator */}
          <div className="flex items-center justify-between mb-5">
            <div className="flex items-center gap-2">
              <motion.div
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.1 }}
                className="h-8 w-8 rounded-xl flex items-center justify-center text-white text-sm font-bold"
                style={{ backgroundColor: "#FF6B4A" }}>
                ↔
              </motion.div>
              <div>
                <p className="text-xs text-muted-foreground font-medium">Swap</p>
                <p className="font-extrabold text-base" style={{ color: "#101828" }}>
                  {t("match_ready")}
                </p>
              </div>
            </div>
            <button onClick={onClose} className="p-1.5 rounded-full hover:bg-black/5 transition">
              <X className="h-5 w-5 text-muted-foreground" />
            </button>
          </div>

          {/* Card preview */}
          <div className="rounded-2xl border border-border p-4 mb-5" style={{ backgroundColor: "white" }}>
            <p className="font-bold text-foreground text-base">{card.title}</p>
            <div className="flex flex-wrap gap-1.5 mt-2">
              {card.tags?.slice(0, 3).map(tag => (
                <span key={tag} className="text-xs px-2.5 py-1 rounded-full bg-muted text-muted-foreground font-medium">{tag}</span>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col gap-3">
            <motion.button
              whileTap={{ scale: 0.97 }}
              onClick={onWriteNow}
              className="w-full py-4 rounded-2xl text-white font-bold text-base transition-all"
              style={{ backgroundColor: "#FF6B4A" }}
            >
              {t("write_now")} →
            </motion.button>
            <motion.button
              whileTap={{ scale: 0.97 }}
              onClick={onSaveLater}
              className="w-full py-3.5 rounded-2xl font-semibold text-sm border-2 transition-all"
              style={{ borderColor: "#101828", color: "#101828", backgroundColor: "transparent" }}
            >
              {t("save_later")}
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}